/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AbstractFinderDialogComponent } from '@gh/common-internal-shared';
import { SlicedDataSource } from '@gh/core-data';
import { TranslationService } from '@gh/core-mls';
import {
  getSalesTaxRateListItemId,
  SalesTaxRateListItem,
} from '../../resources/sales-rate-rate.model';
import {
  SalesTaxRateFinderBusinessService,
  SalesTaxRateFinderDialogConfig,
} from '../../resources/sales-tax-rate-finder-business.service';
import { SalesTaxRateFinderGridDefinition } from './sales-tax-rate-grid-definition.service';

@Component({
  standalone: false,
  selector: 'gh-str-finder-dialog',
  templateUrl: 'sales-tax-rate-finder-dialog.component.html',
  styleUrls: ['sales-tax-rate-finder-dialog.component.scss'],
  providers: [SalesTaxRateFinderGridDefinition],
})
export class SalesTaxRateFinderDialogComponent
  extends AbstractFinderDialogComponent<SalesTaxRateFinderDialogConfig, SalesTaxRateListItem>
  implements OnInit {

  getId = getSalesTaxRateListItemId;

  defaultTitle = this.translations.get('lbl_rfq_str');

  constructor(public gridDefinition: SalesTaxRateFinderGridDefinition,
              private translations: TranslationService,
              private dialogRef: MatDialogRef<any>,
              private businessService: SalesTaxRateFinderBusinessService) {
    super(dialogRef);
  }

  protected buildDataSource(): SlicedDataSource<SalesTaxRateListItem> {
    return this.businessService.findAllAsDataSource();
  }
}
